import userModel from './user';
import * as utils from '../functions/utils';
import * as messageUtils from '../functions/messageUtils';
import { THREE_MONTHS, ChatType, CHAT_TYPES } from '../constants/constants';
import { messageTypes } from '../constants';
import { TYPE_GROUP_CHAT } from '../constants/chatTypes';
import React from 'react';
import { IUserLoginInfo } from '../interfaces/IUser';
import { IChatMessage, IMessageBody, IProfilePhotoComment, IReactionData } from '../interfaces/IMessage';
import { NotificationType } from 'redhotpie-shared-lib/constants/notificationTypes';
import User from './user';
import { MessageStatusType, STATE_STATUS_NULL } from '../constants/messageStatus';

export default class ChatMessage implements IChatMessage {
  msgId: string;
  user: User;
  isDelete: boolean;
  createdAt: Date;
  id: string;
  mid: string;
  sent: boolean;
  received: boolean;
  text: string;
  image: any[];
  read: boolean;
  bySelf: boolean;
  from: string;
  to: string;
  type: ChatType | 'end'; // 'end' is only for video/audio call in messenger
  body: IMessageBody;
  time: number;
  ext: string;
  delay: string;
  error: boolean;
  isHiddenByError: boolean;
  expts: number;
  state: any;
  refMsgId: string | null;
  refUserId: number | null;
  refMsgType: string | null;
  refMsgShortDesc: string | null;
  refMsgIsDeleted: boolean;
  refDisplayName: string | null;
  isProfilePhotoComment?: boolean;
  refMsgTitle: string | null;
  refMsgExpTs: number;
  reactions: IReactionData | null;
  isParsedFromLocal: boolean;
  giftOpened: boolean;
  edited: boolean;
  isLocalMessage: boolean | null;
  profilePhotoComment: IProfilePhotoComment | null;
  notificationType?: NotificationType;
  previousMessage?: ChatMessage | null;
  nextMessage?: ChatMessage | null;
  isHidden?: boolean;
  giftId?: string;
  convId?: number;
  photoData?: string | ArrayBuffer | null;
  conversationKey?: string;
  photoId?: number;
  source?: any;
  status: MessageStatusType;
  hidden?: boolean;

  constructor() {
    this.msgId = ''; // this is message's id from API server
    this.user = new userModel();
    this.isDelete = false;
    this.createdAt = new Date();
    this.id = ''; // this is message's id from XMPP server
    this.mid = ''; // this is message's id from XMPP server
    this.sent = false; // update this field is true to giftchat display message is sent
    this.received = false; // update this field is true to giftchat display message is read
    this.text = ''; // we use giftchat library, this library only need one field in [text, image], if message type = 'text' please remove field image (delete message.image)
    this.image = []; // we use giftchat library, this library only need one field in [text, image], if message type = 'image' please remove field text (delete message.text)
    // extra diff giftchat model
    this.read = false;
    this.bySelf = false; // carefully when use this field, it's used in handle received message (willReceivedProps,
    // xmpp help us detect bySelf), In other case please check field this.user with current login user to know
    this.from = '';
    this.to = '';
    this.type = CHAT_TYPES.CHAT;
    this.body = {} as IMessageBody;
    // Message type text: ==> body: {type: "txt", data: "This is text message"}
    // Message type image: ==> body: {type: "img", data: "http://nexle.domain.com.vn/images/1"}
    // Message type gallery: ==> body: {type: "gallery", data: 13} //note: 13 is gallery id
    this.time = 0;
    this.ext = '';
    this.delay = '';
    this.error = false;
    this.isHiddenByError = false;
    this.expts = 0;
    this.state = null;
    this.refMsgId = null;
    this.refUserId = null;
    this.refMsgType = null;
    this.refMsgShortDesc = null;
    this.refMsgIsDeleted = false;
    this.refDisplayName = null;
    this.refMsgTitle = null;
    this.refMsgExpTs = 0;
    this.reactions = null;
    this.isParsedFromLocal = false;
    this.giftOpened = false;
    this.edited = false;
    this.isLocalMessage = null;
    this.profilePhotoComment = null;
    this.status = STATE_STATUS_NULL;
  }

  static mappingObject(_message: any): IChatMessage {
    _message.from = messageUtils.removePrefixAndSuffix(_message.from);
    _message.to = _message.type === TYPE_GROUP_CHAT ? _message.to : messageUtils.removePrefixAndSuffix(_message.to);
    let message = Object.assign(new ChatMessage(), _message);
    message = utils.cleanObjectKeys(Object.keys(new ChatMessage()), message);
    message.user = userModel.mappingObject(message.user);
    message.state = _message.state || null;
    message.giftOpened = _message.giftOpened || false;
    message.edited = _message.edited || false;
    if (_message.createdAt) {
      message.time = +new Date(_message.createdAt);
    }
    if (message.body?.type === messageTypes.TYPE_IMAGE || message.body?.type === messageTypes.TYPE_INVITE_GROUP_CHAT) {
      let txtExpts = message.expts;
      if (!message.expts) {
        txtExpts = message.createdAt
          ? new Date().getTime() + THREE_MONTHS - (new Date().getTime() - new Date(message.createdAt).getTime())
          : new Date().getTime() + THREE_MONTHS;
      }

      message.expts = txtExpts;
    }
    if (_message.profilePhotoComment) {
      const { userId, photoId, fullUrl, thumbUrl } = _message.profilePhotoComment;
      message.profilePhotoComment = {
        userId,
        photoId,
        fullUrl,
        thumbUrl,
      };
    }
    return message;
  }

  static mappingObjects(_messages: any[]): IChatMessage[] {
    const messages: IChatMessage[] = [];
    _messages.forEach(_message => {
      const message = ChatMessage.mappingObject(_message);
      messages.push(message);
    });
    return messages;
  }
}
